const menuOpen = document.getElementById("menu-open");
const searchOpen = document.getElementById("search-open");
const menuClose = document.getElementById("menu-close");
const html = document.getElementsByTagName("html")[0];
const dropdowns = document.querySelectorAll(".menu--primary .has-children");
const offcanvas = document.querySelector("#menu-offcanvas-items");

function toggleMenu() {
  const expanded =
    "false" === menuOpen.getAttribute("aria-expanded") ? true : false;
  html.classList.toggle("has-active-menu");
  menuOpen.setAttribute("aria-expanded", expanded);
}

function openSearch() {
  const searchInput = document.querySelector(
    "#menu-offcanvas-items .search-form__field"
  );
  const expanded =
    "false" === menuOpen.getAttribute("aria-expanded") ? true : false;
  html.classList.add("has-active-menu");
  menuOpen.setAttribute("aria-expanded", expanded);

  offcanvas.addEventListener(
    "transitionend",
    function (e) {
      searchInput.focus();
    },
    false
  );
}

menuOpen.addEventListener("click", toggleMenu);
menuClose.addEventListener("click", toggleMenu);
searchOpen.addEventListener("click", openSearch);

const windowWidth = window.innerWidth;

if (windowWidth < 1000) {
  addButtons();
}

document.addEventListener("click", function (event) {
  const windowWidth = window.innerWidth;

  if (!event.target.classList.contains("toggle-button")) {
    return;
  }

  if (!event.target.parentElement.classList.contains("has-children")) {
    return;
  }

  // Only run on mobile menu.
  if (windowWidth < 1000) {
    event.preventDefault();
    event.target.nextSibling.classList.add("is-open");
  }
});

// Close submenu on back button click.
document.addEventListener("click", function (event) {
  if (!event.target.classList.contains("menu__link--back")) {
    return;
  }

  event.target.parentElement.parentElement.parentElement.classList.remove(
    "is-open"
  );
});

// Dropdown menus show overlay.
dropdowns.forEach((dropdown) => {
  dropdown.addEventListener("mouseover", () => {
    html.classList.add("has-active-menu");
  });

  dropdown.addEventListener("mouseleave", () => {
    html.classList.remove("has-active-menu");
  });

  dropdown.addEventListener("focusin", () => {
    html.classList.add("has-active-menu");
  });

  dropdown.addEventListener("focusout", () => {
    html.classList.remove("has-active-menu");
  });
});

//add buttons to mobile menu
function addButtons() {
  var menuItemsWithChildren = document.getElementsByClassName("has-children");

  for (let i = 0; i < menuItemsWithChildren.length; i++) {
    var menuItem = document.getElementsByClassName("has-children")[i];
    addButton(menuItem);
  }

  function addButton(x) {
    var newItem = document.createElement("button");

    newItem.setAttribute("class", "toggle-button");

    x.insertBefore(newItem, x.childNodes[1]);
  }
}
